import { PropType, computed, defineComponent, onMounted, onUnmounted } from 'vue'
import { Store } from 'pinia'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import { Point } from '../../../contract/map'
import { flyTo } from '../../chargerMap/mapUtils'
import { useRouter } from 'vue-router'

/**
 * 全国小点渲染功能模块
 */
export default defineComponent({
  name: 'auto-refresh-xinfa-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    mapSetting: {
      type: Object,
      default: {} as { [key: string]: any },
    },
  },
  emits: ['backHome'],
  setup: (props, { emit }) => {
    // const mapContextRef = computed(() => props.mapContextRef)
    const router = useRouter()

    /**
     * 回到首页 Xinfa
     */
    const goBackHome = () => {
      router.go(-1)
      props.mapContextRef &&
        flyTo(props.mapContextRef, props.mapSetting.center as Point, props.mapSetting.zoom)
      emit('backHome')
    }
    props.componentStore.bus.on('goBackHomeXinfa', goBackHome)

    onUnmounted(() => {
      props.componentStore.bus.off('goBackHomeXinfa')
    })

    return () => {}
  },
})
